import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import { API_KEY } from "../constants";

// Secret key for AES encryption
const secretKey = "your-secret-key";

// Function to get the base domain dynamically
const getBaseDomain = () => {
  const domain = window.location.hostname;
  const parts = domain.split(".");

  // Assuming the base domain is the last two parts of the hostname (e.g., "example.com" from "sub1.example.com")
  const baseDomain = parts.slice(-2).join(".");
  return baseDomain;
};

export const setEncryptedCookie = (name, value, options) => {
  if (value === undefined || value === null || value === "") {
    console.error(
      "Cannot encrypt and set cookie: Value is invalid (undefined, null, or empty)."
    );
    return;
  }

  try {
    // Encrypt the cookie value using AES
    const encryptedValue = CryptoJS.AES.encrypt(
      String(value),
      secretKey
    ).toString();

    // Get the base domain dynamically
    const baseDomain = getBaseDomain();

    // Set the cookie with the base domain and other options
    Cookies.set(name, encryptedValue, {
      ...options,
      domain: `.${baseDomain}`, // Set the base domain for the cookie
    });
  } catch (error) {
    console.error("Error setting encrypted cookie:", error);
  }
};

export const getDecryptedCookie = (name) => {
  try {
    const encryptedValue = Cookies.get(name);
    if (!encryptedValue) return null;

    // Decrypt the cookie value using AES
    const bytes = CryptoJS.AES.decrypt(encryptedValue, secretKey);
    const decryptedValue = bytes.toString(CryptoJS.enc.Utf8);

    if (!decryptedValue) {
      console.error("Decryption failed for cookie:", name);
      return null;
    }

    return decryptedValue;
  } catch (error) {
    console.error("Error getting decrypted cookie:", error);
    return null;
  }
};

export const removeCookie = (name) => {
  try {
    // Get the base domain dynamically
    const baseDomain = getBaseDomain();

    // Remove the cookie by setting the domain to the base domain
    Cookies.remove(name, { domain: `.${baseDomain}` });
  } catch (error) {
    console.error("Error removing cookie:", error);
  }
};

export const setCookie = (name, value, days = 7) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000); // Expiry time

  // Get the base domain dynamically
  const baseDomain = getBaseDomain();

  // Set the cookie for the base domain
  document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/; domain=.${baseDomain}`;
};

export const getCookie = (name) => {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(";");

  for (let cookie of cookies) {
    cookie = cookie.trim();
    if (cookie.startsWith(nameEQ)) {
      return cookie.substring(nameEQ.length);
    }
  }
  return null;
};

export const removeSSOCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
};

export const encryptAES = (payload, key, iv) => {
  try {
    const stringPayload = JSON.stringify(payload);
    const iv = "QKXCsTUI4UbID6ys"; // You can generate a random IV if needed

    const encrypted = CryptoJS.AES.encrypt(
      stringPayload,
      CryptoJS.enc.Utf8.parse(API_KEY.AES_KEY),
      {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    return {
      iv,
      encryptedData: encrypted.toString(),
    };
  } catch (error) {
    console.error("Error encrypting payload:", error);
    return null;
  }
};

export const decryptAES = (encryptedPayload, iv) => {
  try {
    const bytes = CryptoJS.AES.decrypt(
      encryptedPayload,
      CryptoJS.enc.Utf8.parse(API_KEY.AES_KEY),
      {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedString);
  } catch (error) {
    console.error("Error decrypting payload:", error);
    return null;
  }
};
export const removeNonBaseDomainCookies = () => {
  try {
    const domainParts = window.location.hostname.split(".");
    const baseDomain = domainParts.slice(-2).join("."); // Example: "example.com" from "sub.example.com"

    // Get all cookies
    const cookies = document.cookie.split(";");

    cookies.forEach((cookie) => {
      const cookieName = cookie.split("=")[0].trim();

      // Remove cookies that have no domain (local cookies)
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;

      // Try removing cookies from other domains dynamically
      for (let i = 0; i < domainParts.length - 1; i++) {
        const testDomain = domainParts.slice(i).join(".");
        if (testDomain !== baseDomain) {
          document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${testDomain}`;
        }
      }
    });

    console.log(`Removed all cookies except those from ${baseDomain}.`);
  } catch (error) {
    console.error("Error removing cookies from non-base domains:", error);
  }
};
